import * as React from "react";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";

interface Props {
  enabled: boolean;
  message: string;
  severety: any;
  onClose: () => void;
}
export default function AlertComponent({ enabled, severety, message, onClose }: Props) {
  //los severities son los colores de las alertas y son: success, info, warning, error
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    setOpen(enabled);
  }, [enabled]);

  return (
    <div>
      {open && (
        <Stack sx={{ width: "100%" }} spacing={2}>
          <Alert severity={severety} onClose={ onClose}>
            {message}
          </Alert>
        </Stack>
      )}
    </div>
  );
}
